import structureTypes from 'common/constants/structureTypes'
import ServerPage from 'src/shared/types/server-page-interface'
import {
  CarouselInterface,
  CarouselItemInterface,
} from 'src/shared/entities/carousel/carousel.schema'
import { migrateMultipleCommand } from 'tools/commands/migrate/utils/migrateMultipleCommand'
import { migrateCarousel, migrateCarouselItem } from './migrateCarousel'

type CarouselEntityType = CarouselInterface | CarouselItemInterface

const migrateFullCarousel = (entity: CarouselEntityType) => {
  switch (entity.type) {
    case structureTypes.CAROUSEL:
      return migrateCarousel as (
        entity: CarouselEntityType,
      ) => CarouselEntityType
    case structureTypes.CAROUSEL_ITEM:
      return migrateCarouselItem as (
        entity: CarouselEntityType,
      ) => CarouselEntityType
    default:
      return (invalidEntity: CarouselEntityType) => {
        console.error('incorrect entity passed to migrateFullCarousel')
        return invalidEntity
      }
  }
}

export default function (page: ServerPage): [ServerPage, boolean] {
  return migrateMultipleCommand({
    page,
    structureTypes: [structureTypes.CAROUSEL, structureTypes.CAROUSEL_ITEM],
    migrateFunction: migrateFullCarousel,
  })
}
